// @flow

// Constants
import { GOOGLE_MAPS_API_KEY, WL_CURRENT_THEME } from '../config';

export const geURLParameters = () => {
  const search = location.search.substring(1);
  let params = {};

  if (search) {
    params = JSON.parse(
      `{"${decodeURI(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"')}"}`
    );
  }

  return params;
};

export const loadGoogleMapsAPI = (callback: string) => {
  const googleMapsScriptTag = document.createElement('script');
  const firstScriptTag = document.getElementsByTagName('script')[0];
  googleMapsScriptTag.src = `https://maps.googleapis.com/maps/api/js?v=3.0&key=${GOOGLE_MAPS_API_KEY}&callback=${callback}`;
  firstScriptTag.parentNode.insertBefore(googleMapsScriptTag, firstScriptTag);
};

export const swapUrlIfNeeded = (url) => {
  if (!url) return url;

  let newUrl = url;

  if (WL_CURRENT_THEME == 'flintco-industrial') {
    newUrl = url.replace('flintco.com', 'flintcoindustrial.com');
  }

  return newUrl;
};
